import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-9 w-full rounded-sm border border-border bg-surface-3 px-3 text-sm text-bone',
        'placeholder:text-muted transition-colors',
        'focus:border-iris focus:outline-none focus:ring-2 focus:ring-iris-dim',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
